import { render, staticRenderFns } from "./EpotForm.vue?vue&type=template&id=36e9cb49&"
import script from "./EpotForm.vue?vue&type=script&lang=js&"
export * from "./EpotForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports